// Meeting outcomes belong to a registration, never to every session of a contact.
export function applyMeetingStatus({contacts,registrations},registrationId,meeting,at=new Date().toISOString()) {
  const registration=registrations.find(item=>item.id===registrationId);
  if (!registration || !['未予約','予約済み'].includes(meeting)) return null;
  const nextRegistrations=registrations.map(item=>item.id===registrationId ? {...item,meeting} : item);
  const summary=nextRegistrations.some(item=>item.contactId===registration.contactId && item.meeting==='予約済み') ? '予約済み' : '未予約';
  return {
    registrations:nextRegistrations,
    contacts:contacts.map(contact=>contact.id===registration.contactId ? {
      ...contact,meeting:summary,lastTouch:at,
      history:[...(contact.history || []),{at,text:`開催回 ${registration.sessionId} の商談予約を「${meeting}」に更新（テスト）`}]
    } : contact)
  };
}
